import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editPreparationItemCommentDialog from '../dialog.editPreparationItemCommentDialog';
import controller from './preparation-item-comment.controller';
import directive from './preparation-item-comment.directive';


export default angular.module('app.components.advisory.auditTrail.preparationItemComment', [
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  editPreparationItemCommentDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amPreparationItemComment', directive)
  .controller('PreparationItemCommentController', controller)
  .name;

console.log('app.components.advisory.auditTrail.preparationItemComment created');
